<template>
  <section>
    <div v-if="loadingStatus">
      <ContentLoader :size="4" :type="'session'"></ContentLoader>
    </div>
    <div
      class="grid gap-8 xl:gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 grid-cols-1"
      v-else
    >
      <div v-for="d in trainerListData" :key="d.id">
        <router-link
          :to="{ name: 'UserTrainerAbout', params: { trainer_id: d.id } }"
        >
          <div
            class="shadow hover:shadow-lg min-h-full rounded-lg ring-1 ring-gray-300"
          >
            <img
              class="w-full card-banner-custom-height rounded-t-lg object-cover"
              :src="baseUrlSrc(d.banner_url)"
              alt="..."
              @error="defaultImage"
            />
            <!-- <div class="flex justify-center">
              <img
                class="widthnheight-3 rounded-full -mt-12 object-cover"
                :src="baseUrlSrc(d.thumbnail_url)"
                @error="defaultCircleImage"
              />
            </div> -->
            <div class="px-3 py-2 space-y-2">
              <div class="flex items-center spae-x-4">
                <div class="flex justify-center">
                  <img
                    class="widthnheight-3 rounded-full object-cover"
                    :src="baseUrlSrc(d.thumbnail_url)"
                    @error="defaultCircleImage"
                  />
                </div>
                <div>
                  <p
                    class="text-2xl pl-2 font-semibold text-ellipses w-full capitalize"
                  >
                    {{ d.name || "-" }}
                  </p>
                  <p class="text-sm text-gray-dark text-ellipses w-full -mt-1">
                    {{ d.category_names || "-" }}
                  </p>
                </div>
              </div>

              <FollowTrainerButton
                :isFollow="d.is_follow"
                :handleUserFollowTrainer="handleUserFollowTrainer"
                :trainerId="d.id"
                classStr="py-2 w-full text-base"
              />

              <div class="flex justify-between mt-4">
                <div class="text-ellipses w-2/4">
                  <p class="text-xs text-gray-dark text-ellipses">Language</p>
                </div>
                <div class="flex justify-center items-center">
                  <Rating :data="d.avg_rating" />
                </div>
              </div>
              <div class="flex justify-between">
                <div class="text-ellipses w-2/4">
                  <p class="text-sm font-medium text-ellipses">
                    {{ d.language_names || "-" }}
                  </p>
                </div>
                <div class="flex justify-end">
                  <span class="text-xs font-medium">{{
                    d.avg_rating || 0
                  }}</span>
                  <span class="text-xs text-gray-dark ml-1">{{
                    `(${d.total_reviews || 0})`
                  }}</span>
                </div>
              </div>
              <div class="border-gray-300 border-b mt-2"></div>
              <div class="flex justify-between mt-2">
                <div
                  class="text-xs text-gray-dark flex justify-center items-center"
                >
                  Price
                </div>
                <div v-if="d.private_cost" class="text-lg font-medium">
                  {{ `${d.private_cost}/hr` }}
                </div>
                <div v-else class="text-base font-medium text-gray-light">
                  N/A
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div v-if="statusCode == 404">
      <div class="md:flex flex-col items-center px-4 mt-12">
        <div>
          <img
            :src="require(`@/assets/img/findSessionsNoData.svg`)"
            class="md:w-96 md:ml-0 ml-2 w-40 object-cover"
          />
        </div>
        <div
          class="md:px-10 mt-4 md:py-0 py-4 flex flex-col items-center justify-center"
        >
          <p class="text-2xl font-semibold tracking-wider">
            There are no results that match your search
          </p>
          <p class="md:text-base mt-2 font-medium text-gray-light">
            Please try adjusting your search keywords or filters.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ContentLoader from "@/components/vue-spinner/ContentLoader";
import { Rating } from "@/components/t-components";
import { mapActions } from "vuex";
import FollowTrainerButton from "@/components/FollowTrainerButton";

export default {
  components: {
    Rating,
    FollowTrainerButton,
    ContentLoader,
  },
  props: {
    trainerListData: Array,
    statusCode: {
      type: Number,
    },
  },
  data() {
    return {
      isDetailsOpen: [],
    };
  },
  computed: {
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  methods: {
    ...mapActions(["userFollowTrainer"]),

    async handleUserFollowTrainer(id, val) {
      if (this.getToken()) {
        const data = {
          trainer_id: id,
          is_follow: val,
        };
        await this.userFollowTrainer(data);
        this.trainerListData.map((d) => {
          if (d.id == id) {
            d.is_follow = val;
          }
        });
      } else {
        this.$router.push({
          name: "Login",
        });
      }
    },
  },
};
</script>

<style scoped>
/* .text-ellipses {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
.card-banner-custom-height {
  height: 5.625rem;
}
.widthnheight-3 {
  height: 3rem;
  width: 3rem;
}
</style>